<script>

import _ from "lodash";

export default {
  name: "sticky-header",
  props: {
    isShowNetProfit: {
      type: Boolean,
      default: false
    },
    isCheckedAll: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      columnWidths: {},
      columnHeight: {},
      columnPadding: {},
      isCheckedAllCopy: false,
    }
  },
  watch: {
    isCheckedAll: {
      handler(v) {
        this.isCheckedAllCopy = v
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('resize', this.setColumnSize);
    window.addEventListener('scroll', this.setColumnSize);
    this.setColumnSize();

    let el = document.getElementById("order-view-thead-wrapper");
    el.addEventListener('scroll', this.onTableScroll)

    this.isCheckedAllCopy = this.isCheckedAll
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setColumnSize);
    window.removeEventListener('scroll', this.setColumnSize);
  },
  methods: {
    onTableScroll() {
      let el = document.getElementsByClassName("repairer-order-part-list")[0];
      let el2 = document.getElementById("order-view-thead-wrapper");
      let topscrollEl = document.getElementsByClassName('topscroll')?.[0]
      if (el2) {
        el.scrollLeft = el2.scrollLeft;
        if (topscrollEl) {
          topscrollEl.scrollLeft = el2.scrollLeft;
        }
      }
    },
    elementStyle(id) {
      let obj = {
        width: this.getWidthForElement(id) + 'px',
        minWidth: this.getWidthForElement(id) + 'px',
        maxWidth: this.getWidthForElement(id) + 'px',
        height: this.getHeightForElement(id) + 'px',
        minHeight: this.getHeightForElement(id) + 'px',
        maxHeight: this.getHeightForElement(id) + 'px',
        paddingRight: this.getPaddingForElement(id, 'right') + ' !important',
        paddingLeft: this.getPaddingForElement(id, 'left') + ' !important',
        paddingTop: this.getPaddingForElement(id, 'top') + ' !important',
        paddingBottom: this.getPaddingForElement(id, 'bottom') + ' !important',
      }
      if (id == 'description-column') {
        obj.left = this.getWidthForElement('line-column') + 'px'
      }
      return obj
    },
    getWidthForElement(id) {
      if (this.columnWidths[id]) {
        return this.columnWidths[id]
      }
      return 0
    },
    getHeightForElement(id) {
      if (this.columnHeight[id]) {
        return this.columnHeight[id]
      }
      return 0
    },
    getPaddingForElement(id, type) {
      if (this.columnPadding?.[id]?.[type]) {
        return this.columnPadding[id][type]
      }
      return 0
    },
    getWidth(id) {
      let el = document.getElementsByClassName(id)?.[0]
      return el?.clientWidth
    },
    getWidthById(id) {
      let el = document.getElementById(id)
      return el?.clientWidth
    },
    getHeight(id) {
      let el = document.getElementsByClassName(id)?.[0]
      let heigth = el.clientHeight
      if (id == 'additional-info') {
        heigth = document.getElementById('sticky-additional-info').clientHeight
        heigth += document.getElementById('supplier-rfq-view-thead-wrapper').clientHeight
      }
      return heigth
    },
    getPadding(id) {
      let el = document.getElementsByClassName(id)?.[0]
      return {
        left: window.getComputedStyle(el, null).getPropertyValue('padding-left'),
        top: window.getComputedStyle(el, null).getPropertyValue('padding-top'),
        right: window.getComputedStyle(el, null).getPropertyValue('padding-right'),
        bottom: window.getComputedStyle(el, null).getPropertyValue('padding-bottom'),
      }
    },
    setColumnSize() {
      let el = document.getElementById("order-view-thead-wrapper");

      // this.setLeftPosition()
      let ids = ['line-column', 'description-column', 'status-id-column', 'number-column', 'type-column',
        'stock-column', 'total-column', 'qty-column', 'qty-rcv-column',
        'rrp-column', 'credit-column', 'status-column', 'delivery-column', 'invoice-column', 'price-column',
        'location-column',]

      if (this.isShowNetProfit) {
        ids.push('profit-column')
      }

      _.forEach(ids, (id) => {
        this.$nextTick(() => {
          this.$set(this.columnWidths, id, this.getWidth(id))
          this.$set(this.columnHeight, id, this.getHeight(id))
          this.$set(this.columnPadding, id, this.getPadding(id))
        })
      })
    },
  }
}
</script>

<template>
  <div
      class="body"
      id="order-view-thead-wrapper"
      style="overflow: auto; overflow-x: auto; overflow-y: hidden;  margin-left: 15px"
      :style="{width: (getWidth('repairer-order-view-table') - 30) + 'px'}"
  >
    <div class="d-flex" :style="{width: getWidthById('order-table') + 'px'}">
      <div class="d-flex header-item" :style="elementStyle('line-column')" style="position: sticky; left: 0px; z-index: 2;">
        <label class="form-check-inline checkbox">
          <input @change="$emit('onChangedCheckedAll')" class="form-check-input" type="checkbox"  v-model="isCheckedAllCopy">
          <span class="icon clickable clickable-active"><i class='bx bx-check'></i></span>
        </label>
        <span>Line</span>
      </div>

      <div class="d-flex header-item" :style="elementStyle('description-column')" style="position: sticky;  z-index: 2;">
        <div class="">Part Description</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'name')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('status-id-column')" style="position: relative; z-index: 1;">

      </div>

      <div class="d-flex header-item" :style="elementStyle('number-column')" style="position: relative; z-index: 1;">
        <div class="">Part Number</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'partNumber')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('type-column')" style="position: relative; z-index: 1;">
        <div class="">Type</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'partType')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('stock-column')" style="position: relative; z-index: 1;">
        <div class="">Stock</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'partStock')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('total-column')" style="position: relative; z-index: 1;">
        <div class="">Cost</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'total')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('qty-column')" style="position: relative; z-index: 1;">
        <div class="">Qty Order</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'qty')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('qty-rcv-column')" style="position: relative; z-index: 1;">
        <div class="">Qty Rcvd</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'qtyRcv')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('rrp-column')" style="position: relative; z-index: 1;">
        <div class="">Unit List</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'rrp')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('price-column')" style="position: relative; z-index: 1;">
        <div class="">Unit Net</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'price')"></span></div>
      </div>

      <div v-if="isShowNetProfit" class="d-flex header-item" :style="elementStyle('profit-column')" style="position: relative; z-index: 1;">
        <div class="">Net Profit</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'netProfit')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('credit-column')" style="position: relative; z-index: 1;">
        <div class="">Credit</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'credit')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('status-column')" style="position: relative; z-index: 1;">
        <div class="">Status</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'status')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('delivery-column')" style="position: relative; z-index: 1;">
        <div class="">Delivery Date</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'supplierDeliveryDate')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('invoice-column')" style="position: relative; z-index: 1;">
        <div class="">Invoice</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'invoiceNumber')"></span></div>
      </div>

      <div class="d-flex header-item" :style="elementStyle('location-column')" style="position: relative; z-index: 1;">
        <div class="">Location</div>
        <div class=""> <span class="order-sort-icon" @click="$emit('sortBy', 'workshopLocation')"></span></div>
      </div>
    </div>
  </div>
</template>

<style>
#order-view-thead-wrapper {
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
}
#order-view-thead-wrapper::-webkit-scrollbar {
  display: none;  /* Safari and Chrome */
}

.order-sort-icon {
  background-image: url(data:image/svg+xml;base64,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);
  height: 16px;
  width: 8px;
  display: inline-block;
  cursor: pointer;
  margin-left: 5px;
}

</style>
<style scoped>
.clickable-active >>> i{
  height: 25px;
  color: #fdfdfd !important;
  border-radius: 3px;
  background-color: #77afb9;
}
.body{
  width: calc(100vw - 270px);
}
.header-item {
  border: 0px !important;
  background-color: rgb(227, 228, 231) !important;
  color: #212529;
  padding: 15px 10px !important;
  font-size: 13px !important;
  line-height: 18px !important;
  letter-spacing: normal;
  font-weight: 700 !important;
  flex: 1 1 auto;
  align-items: flex-end;
}
.header-item:nth-child(1){
  padding: 15px 5px !important;
  height: 66px;
  min-width: 80px;
}

.header-item:nth-child(2){
  min-width: 200px;
  max-width: 200px;
}
.header-item:nth-child(3){
  min-width: 80px;
  max-width: 80px;
}
.header-item:nth-child(4){
  min-width: 150px;
}
.header-item:nth-child(5){
  min-width: 80px;
  max-width: 80px;
}
.header-item:nth-child(6){
  min-width: 122px;
  max-width: 122px;
}
.header-item:nth-child(8), .header-item:nth-child(9){
  flex: 0 1 auto;
  width: 62px;
}
.header-item:nth-child(7){
  max-width: 80px;
  min-width: 80px;
  justify-content: center;
}
.header-item:nth-child(8), .header-item:nth-child(9), .header-item:nth-child(10), .header-item:nth-child(11){
  flex: 0 1 auto;
  max-width: 80px;
  min-width: 80px;
  text-align: center;
}
.header-item:nth-child(8) div:last-child, .header-item:nth-child(9) div:last-child, .header-item:nth-child(10) div:last-child, .header-item:nth-child(11) div:last-child{
  position: relative;
  right: 5px;
}
.header-item:nth-child(9){
  min-width: 80px;
  justify-content: center;
}
.header-item:nth-child(10){
  min-width: 80px;
  justify-content: center;
}
.header-item:nth-child(12){
  min-width: 110px;
  justify-content: center;
}
.header-item:nth-child(13){
  min-width: 110px;
}
.header-item:nth-child(14){
  min-width: 110px;
}
.header-item:nth-child(15){
  min-width: 150px;
  justify-content: center;
}
.header-item:nth-child(16){
  min-width: 110px;
  justify-content: center;
}
.header-item:nth-child(17){
  min-width: 96px;
}
@media screen and (max-width: 1860px) {
  .header-item:nth-child(13){
    flex: 0 1 auto;
    max-width: 117px;
  }
}
</style>
